import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonModule, DIALOG_DATA, DialogRef, IconModule, WithDigitGroupsPipe } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { StatusComponent } from '@kr/components';
import { Transaction } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';
import { ClipboardService } from '@kr/services';

@Component({
  imports: [DatePipe, TranslateModule, IconModule, ButtonModule, StatusComponent, WithDigitGroupsPipe, CurrencyBalanceFormatPipe],
  selector: 'kr-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionDetailsComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly #data = inject<{ transaction: Transaction }>(DIALOG_DATA);
  clipboard = inject(ClipboardService);

  transaction: Transaction;

  get coinDisplayName(): string {
    return this.transaction.coin?.secondaryCoin ? this.transaction.coin?.secondaryCoin.displayName : this.transaction.coin?.displayName;
  }

  constructor() {
    this.transaction = this.#data.transaction;
  }

  close(): void {
    this.#dialogRef.close();
  }
}
